module.exports = __webpack_public_path__ + "trials_watch_dogs_background_tablet.png";